/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OtherContactMethods/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import PleaseWait from './PleaseWait/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function OtherContactMethods({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/OtherContactMethods"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let signupConfirmRequestValueData = fromData.useDataFormat({ viewPath,
context: 'signup_confirm_request',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: signupConfirmRequestValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PleaseWait'}>
<PleaseWait
  viewPath={`${viewPath}/PleaseWait`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}